import { gql } from "@apollo/client";

export const READ_VERSIONS_QUERY_NAME = "GetVersions";
export const READ_VERSIONS_QUERY = gql`
  query ${READ_VERSIONS_QUERY_NAME}(
    $cursor: String
    $first: Int = 25
    $version__icontains: String
  ) {
    essentials {
      versions(
        after: $cursor
        first: $first
        version__icontains: $version__icontains
      ) {
        edges {
          node {
            version
            description
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;

export const CREATE_VERSION_MUTATION_NAME = "CreateVersionMutation";
export const CREATE_VERSION_MUTATION = gql`
  mutation ${CREATE_VERSION_MUTATION_NAME}($description: String!, $version: String!) {
    create_essentials_version(description: $description, version: $version) {
      success
      message
    }
  }
`;

export const DELETE_VERSION_MUTATION_NAME = "DeleteVersionMutation";
export const DELETE_VERSION_MUTATION = gql`
  mutation ${DELETE_VERSION_MUTATION_NAME}($ids: [String!]!) {
    delete_essentials_version(versions: $ids) {
      success
      message
    }
  }
`;

const EVENTS_FRAGMENT = gql`
  fragment TEventTypeFragment on TVersionType {
    events {
      file_type
      filename
      id_event
    }
  }
`;

const XML_FRAGMENT = gql`
  fragment TXmlFileTypeFragment on TVersionType {
    assigned_xmls {
      id_xml
    }
    is_assigned {
      neo
      pmax
    }
  }
`;

const IQ_CONFIG_FRAGMENT = gql`
  fragment TIQConfigTypeFragment on TVersionType {
    iq_config {
      filename
      id_config
    }
  }
`;

const IQ_PATCH_TAG_FRAGMENT = gql`
  fragment TIQPatchTagsType on TVersionType {
    iq_patch_tags {
      id_file
      patch_tags
    }
  }
`;

const EMAIL_TEMPLATES_FRAGMENT = gql`
  fragment TVersionTypeFragment on TVersionType {
    email_templates {
      filename
      description
      id_file
    }
  }
`;

export const READ_VERSION_FILES_QUERY_NAME = "GetVersionFiles";
export const READ_VERSION_FILES_QUERY = gql`
  ${EVENTS_FRAGMENT}
  ${XML_FRAGMENT}
  ${IQ_CONFIG_FRAGMENT}
  ${IQ_PATCH_TAG_FRAGMENT}
  ${EMAIL_TEMPLATES_FRAGMENT}
  query ${READ_VERSION_FILES_QUERY_NAME}($version: String) {
    essentials {
      versions(version: $version) {
        edges {
          node {
            id_version
            ...TEventTypeFragment
            ...TXmlFileTypeFragment
            ...TIQConfigTypeFragment
            ...TIQPatchTagsType
            ...TVersionTypeFragment
          }
        }
      }
    }
  }
`;

export const CREATE_VERSION_EVENT_FILE = gql`
  mutation CreateVersionEventFile(
    $file: Upload!
    $version: String!
    $type: EventTypeEnum!
  ) {
    create_event_file_version(file: $file, version: $version, type: $type) {
      success
      message
    }
  }
`;

export const DELETE_VERSION_EVENT_FILE = gql`
  mutation DeleteVersionEventFile($ids: [Int!]!) {
    delete_event_file_version(ids: $ids) {
      success
      message
    }
  }
`;

export const READ_VERSION_LANGUAGES_QUERY_NAME = "GetVersionLanguages";
export const READ_VERSION_LANGUAGES_QUERY = gql`
  query ${READ_VERSION_LANGUAGES_QUERY_NAME}($version: String) {
     essentials {
      versions(version: $version) {
        edges {
          node {
            locales {
              id_locale
              locale
              locale_files {
                filename
                id_file
              }
            }
          }
        }
      }
    }
  }
`;

export const CREATE_VERSION_LOCALE_MUTATION = gql`
  mutation CreateVersionLocale($version: String!, $locale: String!) {
    create_locale(version: $version, locale: $locale) {
      success
    }
  }
`;

export const DELETE_VERSION_LOCALE_MUTATION = gql`
  mutation DeleteVersionLocale($ids: [Int!]!) {
    delete_locale(ids: $ids) {
      success
    }
  }
`;

export const CREATE_LOCALE_FILE_MUTATION = gql`
  mutation CreateLocaleFile($id_locale: Int!, $files: [Upload]!) {
    create_locale_file(files: $files, id_locale: $id_locale) {
      success
    }
  }
`;

export const DELETE_LOCALE_FILE_MUTATION = gql`
  mutation DeleteLocaleFile($ids: [Int!]!) {
    delete_locale_file(ids: $ids) {
      success
    }
  }
`;

export const READ_VERSIONS_XMLS_QUERY_NAME = "ReadVersionsXmls";
export const READ_VERSIONS_XMLS_QUERY = gql`
  query ${READ_VERSIONS_XMLS_QUERY_NAME}(
    $cursor: String
    $first: Int = 25
    $filename__icontains: String
    $xml_type: RepoTXmlXmlTypeChoices
  ) {
    essentials {
      xmls(
        after: $cursor
        first: $first
        filename__icontains: $filename__icontains
        xml_type: $xml_type
      ) {
        edges {
          node {
            id_xml
            filename
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;

export const UPLOAD_VERSION_XML_FILE_MUTATION_NAME = "UploadVersionXmlFile";
export const UPLOAD_VERSION_XML_FILE_MUTATION = gql`
  mutation ${UPLOAD_VERSION_XML_FILE_MUTATION_NAME}($files: [Upload]!, $type: XmlTypeEnum!) {
    create_xml_file(files: $files, type: $type) {
      success
    }
  }
`;

export const ASSIGN_VERSION_XML_FILE_MUTATION_NAME = "AssignVersionXmlFile";
export const ASSIGN_VERSION_XML_FILE_MUTATION = gql`
  mutation ${ASSIGN_VERSION_XML_FILE_MUTATION_NAME}($id_version: [Int!]!, $id_xml: [Int!]!) {
    create_assign_xml(id_version: $id_version, id_xml: $id_xml) {
      success
    }
  }
`;

export const UNASSIGN_VERSION_XML_FILE_MUTATION_NAME = "UnassignVersionXmlFile";
export const UNASSIGN_VERSION_XML_FILE_MUTATION = gql`
  mutation ${UNASSIGN_VERSION_XML_FILE_MUTATION_NAME}($id_version: [Int!]!, $id_xml: [Int!]!) {
    delete_assign_xml(id_version: $id_version, id_xml: $id_xml) {
      success
    }
  }
`;

export const DELETE_XML_FILE_MUTATION_NAME = "DeleteXMLFile";
export const DELETE_XML_FILE_MUTATION = gql`
  mutation ${DELETE_XML_FILE_MUTATION_NAME}($ids: [Int!]!) {
    delete_xml_file(ids: $ids) {
      success
    }
  }
`;

export const UPLOAD_IQ_CONFIG_FILE = gql`
  mutation CreateIQConfigFile($file: Upload!, $version: String!) {
    create_iq_config_file_version(file: $file, version: $version) {
      success
    }
  }
`;

export const DELETE_IQ_CONFIG_FILE = gql`
  mutation DeleteIQConfigFile($ids: [Int!]!) {
    delete_iq_config_file_version(ids: $ids) {
      success
    }
  }
`;

export const UPLOAD_IQ_PATCH_TAG_FILE = gql`
  mutation CreateIQPatchTagsFile($version: String!, $file: Upload!) {
    create_iq_patch_tags_file_version(file: $file, version: $version) {
      message
      success
    }
  }
`;

export const DELETE_IQ_PATCH_TAG_FILE = gql`
  mutation DeleteIQPatchTagsFile($ids: [Int!]!) {
    delete_iq_patch_tags_file_version(ids: $ids) {
      message
      success
    }
  }
`;

export const UPDATE_IQ_PATCH_TAG_FILE = gql`
  mutation UpdateIQPatchTagsFile($iq_patch_tags: [String]!, $version: String!) {
    update_iq_patch_tags_file_version(
      version: $version
      iq_patch_tags: $iq_patch_tags
    ) {
      message
      success
    }
  }
`;

export const UPLOAD_EMAIL_TEMPLATE = gql`
  mutation UploadVersionEmailTemplateFile(
    $version: String!
    $file: Upload!
    $description: String
  ) {
    create_email_template_file_version(
      file: $file
      version: $version
      description: $description
    ) {
      message
      success
    }
  }
`;

export const DELETE_EMAIL_TEMPLATE = gql`
  mutation DeleteVersionEmailTemplateFiles($ids: [Int!]!) {
    delete_email_template_file_version(ids: $ids) {
      message
      success
    }
  }
`;
